import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {

  @ViewChild('captchaCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;

  username = '';
  password = '';
  reponseCaptcha = '';
  champPiege = ''; // honeypot : un vrai utilisateur ne remplit jamais ce champ invisible

  messageErreur = '';
  messageBlocage = '';
  boutonDesactive = false;

  private captchaTexte = '';
  private pageChargeeA = 0;

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.pageChargeeA = Date.now();
    this.verifierBlocage();
  }

  ngAfterViewInit(): void {
    this.genererCaptcha();
  }

  // ---------- Captcha visuel (texte deforme sur canvas) ----------
  genererCaptcha(): void {
    const caracteres = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // sans caracteres ambigus
    this.captchaTexte = '';
    for (let i = 0; i < 5; i++) {
      this.captchaTexte += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }

    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const degrade = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    degrade.addColorStop(0, '#111d33');
    degrade.addColorStop(1, '#0c1424');
    ctx.fillStyle = degrade;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Lignes de bruit pour gener une lecture automatique
    for (let i = 0; i < 6; i++) {
      ctx.strokeStyle = `rgba(201,162,75,${(Math.random() * 0.35 + 0.1).toFixed(2)})`;
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    const largeurParCaractere = canvas.width / this.captchaTexte.length;
    for (let i = 0; i < this.captchaTexte.length; i++) {
      ctx.save();
      const x = largeurParCaractere * i + largeurParCaractere / 2;
      const y = canvas.height / 2 + (Math.random() * 10 - 5);
      ctx.translate(x, y);
      ctx.rotate(Math.random() * 0.6 - 0.3);
      ctx.font = `bold ${24 + Math.floor(Math.random() * 6)}px Georgia, serif`;
      ctx.fillStyle = Math.random() > 0.5 ? '#e9cd8c' : '#f4eee0';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(this.captchaTexte[i], 0, 0);
      ctx.restore();
    }

    this.reponseCaptcha = '';
    this.pageChargeeA = Date.now();
  }

  // ---------- Protection anti-force-brute : limite les tentatives ----------
  private getEtatTentatives(): { nombre: number; bloqueJusqua: number } {
    const brut = localStorage.getItem('fis_tentatives_connexion');
    return brut ? JSON.parse(brut) : { nombre: 0, bloqueJusqua: 0 };
  }

  private sauverEtatTentatives(etat: { nombre: number; bloqueJusqua: number }): void {
    localStorage.setItem('fis_tentatives_connexion', JSON.stringify(etat));
  }

  verifierBlocage(): boolean {
    const etat = this.getEtatTentatives();
    const maintenant = Date.now();

    if (etat.bloqueJusqua > maintenant) {
      const secondesRestantes = Math.ceil((etat.bloqueJusqua - maintenant) / 1000);
      this.messageBlocage = `Trop de tentatives échouées. Réessayez dans ${secondesRestantes} seconde(s).`;
      this.boutonDesactive = true;
      setTimeout(() => this.verifierBlocage(), 1000);
      return true;
    }

    this.messageBlocage = '';
    this.boutonDesactive = false;
    return false;
  }

  private enregistrerEchec(): void {
    const etat = this.getEtatTentatives();
    etat.nombre += 1;

    if (etat.nombre >= 3) {
      etat.bloqueJusqua = Date.now() + 30000; // 30 secondes de blocage
      etat.nombre = 0;
    }

    this.sauverEtatTentatives(etat);
    this.verifierBlocage();
  }

  // ---------- Connexion ----------
  seConnecter(): void {
    if (this.verifierBlocage()) return;

    this.messageErreur = '';

    // Champ piege rempli -> tres probablement un robot, on rejette silencieusement
    if (this.champPiege) {
      this.messageErreur = 'Identifiant, mot de passe ou vérification incorrects.';
      this.genererCaptcha();
      this.enregistrerEchec();
      return;
    }

    // Formulaire envoye trop vite (moins d'1,5 seconde) -> suspect
    if (Date.now() - this.pageChargeeA < 1500) {
      this.messageErreur = 'Merci de patienter un instant avant de valider.';
      this.genererCaptcha();
      this.enregistrerEchec();
      return;
    }

    // Verification du captcha (insensible a la casse)
    if (this.reponseCaptcha.trim().toUpperCase() !== this.captchaTexte) {
      this.messageErreur = 'Le code de vérification ne correspond pas.';
      this.genererCaptcha();
      this.enregistrerEchec();
      return;
    }

    this.authService.login(this.username, this.password).subscribe({
      next: (reponse) => {
        if (reponse.success) {
          this.sauverEtatTentatives({ nombre: 0, bloqueJusqua: 0 }); // reinitialise apres succes
          this.router.navigate(['/admin/dashboard']);
        } else {
          this.messageErreur = reponse.message;
          this.genererCaptcha();
          this.enregistrerEchec();
        }
      },
      error: () => {
        this.messageErreur = 'Erreur de connexion au serveur.';
        this.genererCaptcha();
      }
    });
  }
}
